export default __webpack_public_path__ + "static/media/logo-contra-capa.300e164f.png";